import { Injectable } from '@angular/core';
import { DonneReferenceService } from '../../../shared/services/donne-reference.service';
import {
  SelectionnerPropriete,
  StoreProrieteDetails,
  SetCurrentPage,
  ModifierPropriete,
  CreerPropriete
} from '../../propriete.state';
import { GTM_PUSH_CATEGORY_INTERRACTIONS_PAGES, GTM_PUSH_CATEGORY } from '../../../shared/modeles/variables';
import { Store } from '@ngxs/store';
import { GtmService } from '../../../shared/services/gtm.service';
import { AppConfigService } from '../../../app-config.service';
import { FormGroup } from '@angular/forms';
import { ProprieteHelper } from '../../modeles/ProprieteHelper';
import { Router } from '@angular/router';
import { ProprieteModele } from '../../modeles/proprieteModel';

@Injectable()
export class FormPropertyService {
  fraisRenovationsMaxInput: number;

  constructor(
    private readonly _donneesReferencesService: DonneReferenceService,
    private readonly _store: Store,
    private readonly _gtm: GtmService,
    private readonly _appConfigService: AppConfigService,
    private readonly _router: Router
  ) {}

  isFrench(): boolean {
    return this._appConfigService.configData.contexteEnvironnement.langue === 'fr';
  }

  setCurrentPage(): void {
    this._store.dispatch([new StoreProrieteDetails(null), new SetCurrentPage('creation')]);
  }

  getTitle(formMode: string) {
    return formMode === 'create' ? 'propriete.creation.titre' : 'propriete.modifier.titre';
  }

  get contactPhoneNumber() {
    return {
      phoneNumberToCall: this._donneesReferencesService.numerosDemandeSupport.montreal,
      tollFreeNumber: this._donneesReferencesService.numerosDemandeSupport.sansFrais
    };
  }

  fetchData(currentId: string) {
    return this._store.dispatch(new SelectionnerPropriete(currentId)).toPromise();
  }

  pushDebuteEvent(): void {
    this._gtm.pushEvent({
      event: GTM_PUSH_CATEGORY_INTERRACTIONS_PAGES,
      category: GTM_PUSH_CATEGORY,
      label: 'paiement',
      action: 'debute',
      value: 0,
      nonInteraction: false
    });
  }

  pushCreatedEvent(property: ProprieteModele) {
    this._gtm.pushEvent({
      event: GTM_PUSH_CATEGORY_INTERRACTIONS_PAGES,
      category: GTM_PUSH_CATEGORY,
      label: property.montantFraisRenovations ? property.montantFraisRenovations : 0,
      action: 'couts supplementaires',
      value: 0,
      nonInteraction: false
    });

    this._gtm.pushEvent({
      event: GTM_PUSH_CATEGORY_INTERRACTIONS_PAGES,
      category: GTM_PUSH_CATEGORY,
      label: property.prix,
      action: 'Prix maison',
      value: 0,
      nonInteraction: false
    });

    this._gtm.pushEvent({
      event: GTM_PUSH_CATEGORY_INTERRACTIONS_PAGES,
      category: GTM_PUSH_CATEGORY,
      label: 'paiement',
      action: 'complete',
      value: 0,
      nonInteraction: false
    });

    this._gtm.pushEvent({
      event: GTM_PUSH_CATEGORY_INTERRACTIONS_PAGES,
      category: GTM_PUSH_CATEGORY,
      label: this._gtm.urlProvenance,
      action: 'Conversion - paiement',
      value: 0,
      nonInteraction: false
    });
  }

  updateMontantFraisRenovationsMaxInput(price: number) {
    this.fraisRenovationsMaxInput = ProprieteHelper.MAX_TOTAL_PRICE_EXCLUSIVE - price - 1;
  }

  submitToApi(form: FormGroup, formMode: string) {
    const isEditing: boolean = formMode === 'edit';
    const actionUpdateProperty = isEditing ? new ModifierPropriete(form.value) : new StoreProrieteDetails(form.value);
    if (isEditing) {
      return this._store.dispatch(actionUpdateProperty);
    } else {
      const actionCreateProperty = new CreerPropriete(form.value);
      return this._store.dispatch([actionUpdateProperty, actionCreateProperty]);
    }
  }

  async navigateToReturnUrl() {
    const route = this._store.selectSnapshot(state => state.propriete.returnRoute);
    await this._router.navigateByUrl(route || 'propriete/liste');
  }
}
